import "core-js/modules/es.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticStyle: {
      width: "100%",
      display: "flex",
      "flex-direction": "column"
    }
  }, [_c("a-alert", {
    staticStyle: {
      "margin-bottom": "24px"
    },
    attrs: {
      message: _vm.$t("public.reminder"),
      description: _vm.$t("hotwords.remindcontent"),
      type: "warning",
      "show-icon": "",
      closable: ""
    },
    on: {
      close: _vm.onClose
    }
  }), _c("div", {
    staticClass: "calssifica_div",
    staticStyle: {
      position: "relative",
      flex: "1 1 0%"
    }
  }, [_c("a-card", {
    attrs: {
      bordered: false
    }
  }, [_c("div", [_c("a-card", {
    attrs: {
      bordered: false,
      size: "small"
    }
  }, [_c("a-col", {
    attrs: {
      align: "right"
    }
  }, [_c("a-button", {
    staticStyle: {
      "margin-bottom": "16px"
    },
    attrs: {
      type: "primary",
      icon: "plus"
    },
    on: {
      click: function click($event) {
        return _vm.addModal();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("hotwords.new")) + " ")])], 1)], 1), _c("a-table", {
    attrs: {
      id: "sorttableclass",
      rowKey: "id",
      columns: _vm.columns,
      loading: _vm.isTableLoading,
      "data-source": _vm.hotwordsList,
      pagination: false
    },
    scopedSlots: _vm._u([{
      key: "keyword",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("a-tooltip", {
          attrs: {
            placement: "top"
          }
        }, [_c("template", {
          slot: "title"
        }, [_vm._v(" " + _vm._s(record.keyword) + " ")]), _c("span", {
          staticClass: "tooltipCenter"
        }, [_vm._v(_vm._s(record.keyword))])], 2)], 1);
      }
    }, {
      key: "action",
      fn: function fn(text, record) {
        return _c("span", {}, [_c("a", {
          on: {
            click: function click($event) {
              return _vm.updata(record);
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("hotwords.edit")))]), _c("a-divider", {
          attrs: {
            type: "vertical"
          }
        }), _c("a-popconfirm", {
          attrs: {
            title: _vm.$t("hotwords.suerdelete"),
            "ok-text": _vm.$t("hotwords.determine"),
            "cancel-text": _vm.$t("hotwords.cancel")
          },
          on: {
            confirm: function confirm($event) {
              return _vm.confirm(record);
            },
            cancel: _vm.cancel
          }
        }, [_c("a", {
          attrs: {
            href: "#"
          }
        }, [_vm._v(_vm._s(_vm.$t("hotwords.delete")))])])], 1);
      }
    }])
  })], 1)]), _c("a-modal", {
    staticClass: "hotwordsmodal",
    attrs: {
      title: _vm.textMap[_vm.dialogStatus],
      destroyOnClose: "",
      maskClosable: false
    },
    model: {
      value: _vm.visible,
      callback: function callback($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_c("a-form-model", {
    ref: "dataForm",
    attrs: {
      model: _vm.datavalue,
      id: "modal"
    }
  }, [_vm._l(_vm.datavalue.list, function (tempObj, index) {
    return [tempObj.required ? [_c("a-form-model-item", {
      key: index,
      attrs: {
        label: tempObj.titleName,
        prop: "list." + index + ".name",
        rules: [{
          required: true,
          message: _vm.nameErr,
          trigger: "blur"
        }]
      }
    }, [_c("a-input", {
      attrs: {
        allowClear: true,
        placeholder: _vm.$t("hotwords.categorynameprop"),
        maxLength: 20
      },
      model: {
        value: tempObj.name,
        callback: function callback($$v) {
          _vm.$set(tempObj, "name", $$v);
        },
        expression: "tempObj.name"
      }
    })], 1)] : [_c("a-form-model-item", {
      key: "second" + index,
      attrs: {
        label: tempObj.titleName
      }
    }, [_c("a-input", {
      attrs: {
        allowClear: true,
        placeholder: _vm.$t("hotwords.categorynameprop"),
        maxLength: 20
      },
      model: {
        value: tempObj.name,
        callback: function callback($$v) {
          _vm.$set(tempObj, "name", $$v);
        },
        expression: "tempObj.name"
      }
    })], 1)]];
  })], 2), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    on: {
      click: function click($event) {
        return _vm.resetFormDate();
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("hotwords.cancel")))]), _vm.dialogStatus == "create" ? _c("a-button", {
    attrs: {
      loading: _vm.saveLoading,
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.sureSave();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("hotwords.determine")) + " ")]) : _vm._e(), _vm.dialogStatus == "update" ? _c("a-button", {
    attrs: {
      loading: _vm.updateLoading,
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.updateUser();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("hotwords.determine")) + " ")]) : _vm._e()], 1)], 2)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };